import ApiRequestManagerInstance from '../ApiRequestManager';
import TranslationManager from '../../assets/locale/translationsManager';
import { store } from '../../store/store';
import { ISliderRequest } from '../../types/interfaces/slider';
import Slider from '../../classes/slider';

function addonPromoRequest(id: string) {
  const promise = new Promise<Slider[]>(async (resolve) => {
    try {
      const { user, channels: storeChannels } = store.getState();
      const response: ISliderRequest = (await ApiRequestManagerInstance.get({
        endpoint: {
          url: 'apiUrl',
          section: `media${user.isAnonymous ? 'free' : ''}`,
          subsection: 'addon',
          type: 'promos',
          params: id + '?lang=' + TranslationManager.currentLanguage,
        },
      })) as ISliderRequest;
      let promos: Slider[] = [];
      if (response?.data?.length) {
        promos = response.data?.map((item, index) => new Slider(item, index));
      }
      resolve(
        promos.filter((promo) => {
          return storeChannels.channelsData?.find((ch) => {
            return promo?.channel?.id === ch.id;
          });
        })
      );
    } catch (e) {
      resolve([]);
    }
  });

  return promise;
}

export default addonPromoRequest;
